import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const Article = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <rect
          width="248"
          height="143"
          rx="8"
          fill="#FFCBCB"
        />
        <path
          d="M72.0104 96.8646V47.1354C72.0104 45.9364 72.4867 44.7865 73.3345 43.9387C74.1823 43.0909 75.3322 42.6146 76.5312 42.6146H171.469C172.668 42.6146 173.818 43.0909 174.665 43.9387C175.513 44.7865 175.99 45.9364 175.99 47.1354V96.8646H72.0104Z"
          fill="#66E1FF"
        />
        <path
          d="M151.125 42.6146H76.5312C75.3322 42.6146 74.1823 43.0909 73.3345 43.9387C72.4867 44.7865 72.0104 45.9364 72.0104 47.1354V96.8646H96.875L151.125 42.6146Z"
          fill="#C2F3FF"
        />
        <path
          d="M72.0104 96.8646H175.99V105.906C175.99 107.105 175.513 108.255 174.665 109.103C173.818 109.951 172.668 110.427 171.469 110.427H76.5312C75.3322 110.427 74.1823 109.951 73.3345 109.103C72.4867 108.255 72.0104 107.105 72.0104 105.906V96.8646Z"
          fill="white"
        />
        <path
          d="M166.948 42.6146H171.469C172.668 42.6146 173.818 43.0909 174.665 43.9387C175.513 44.7865 175.99 45.9364 175.99 47.1354V105.906C175.99 107.105 175.513 108.255 174.665 109.103C173.818 109.951 172.668 110.427 171.469 110.427H76.5312C75.3322 110.427 74.1823 109.951 73.3345 109.103C72.4867 108.255 72.0104 107.105 72.0104 105.906V47.1354C72.0104 45.9364 72.4867 44.7865 73.3345 43.9387C74.1823 43.0909 75.3322 42.6146 76.5312 42.6146H81.0521"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M101.396 123.99H146.604"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.781 110.427H117.219V123.99H130.781V110.427Z"
          fill="#E3E3E3"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M158 30H90V96H158V30Z"
          fill="white"
        />
        <path
          d="M157.906 30.0937H90.0938V24.5312C90.0938 23.3322 90.5701 22.1823 91.4179 21.3345C92.2657 20.4867 93.4156 20.0104 94.6146 20.0104H153.385C154.584 20.0104 155.734 20.4867 156.582 21.3345C157.43 22.1823 157.906 23.3322 157.906 24.5312V30.0937Z"
          fill="white"
        />
        <path
          d="M90.0938 89.8229V24.5312C90.0938 23.3322 90.5701 22.1823 91.4179 21.3345C92.2657 20.4867 93.4156 20.0104 94.6146 20.0104H153.385C154.584 20.0104 155.734 20.4867 156.582 21.3345C157.43 22.1823 157.906 23.3322 157.906 24.5312V89.8229"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.958 69.0044H101.396C100.796 69.0044 100.221 69.2425 99.7976 69.6665C99.3736 70.0904 99.1355 70.6653 99.1355 71.2648V84.8273C99.1355 85.4268 99.3736 86.0018 99.7976 86.4257C100.221 86.8496 100.796 87.0877 101.396 87.0877H114.958C115.558 87.0877 116.133 86.8496 116.557 86.4257C116.981 86.0018 117.219 85.4268 117.219 84.8273V71.2648C117.219 70.6653 116.981 70.0904 116.557 69.6665C116.133 69.2425 115.558 69.0044 114.958 69.0044Z"
          fill="#66E1FF"
        />
        <path
          d="M116.559 69.66C116.348 69.4503 116.099 69.284 115.824 69.1707C115.55 69.0575 115.255 68.9995 114.958 69H101.396C100.796 69 100.221 69.2382 99.7976 69.6621C99.3737 70.086 99.1355 70.6609 99.1355 71.2604V84.8229C99.135 85.12 99.193 85.4142 99.3062 85.6888C99.4195 85.9634 99.5858 86.213 99.7955 86.4233L116.559 69.66Z"
          fill="#C2F3FF"
        />
        <path
          d="M114.958 69.0044H101.396C100.796 69.0044 100.221 69.2425 99.7976 69.6665C99.3736 70.0904 99.1355 70.6653 99.1355 71.2648V84.8273C99.1355 85.4268 99.3736 86.0018 99.7976 86.4257C100.221 86.8496 100.796 87.0877 101.396 87.0877H114.958C115.558 87.0877 116.133 86.8496 116.557 86.4257C116.981 86.0018 117.219 85.4268 117.219 84.8273V71.2648C117.219 70.6653 116.981 70.0904 116.557 69.6665C116.133 69.2425 115.558 69.0044 114.958 69.0044Z"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M126.219 74.0439H148.366"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M126.219 82.0439H148.366"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M72.0104 96.8646H175.99"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M90.0938 30.0938H157.906"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M110 40C110 39.4477 110.448 39 111 39H183C183.552 39 184 39.4477 184 40V56.7001C184 57.2523 183.552 57.7001 183 57.7001H111C110.448 57.7001 110 57.2523 110 56.7001V40Z"
          fill="white"
          stroke="#1E1E1E"
          strokeWidth="2"
        />
        <path
          d="M114.393 45.354V44.3735C114.393 44.1135 114.496 43.8641 114.68 43.6802C114.864 43.4963 115.113 43.393 115.374 43.393H122.237C122.497 43.393 122.747 43.4963 122.931 43.6802C123.114 43.8641 123.218 44.1135 123.218 44.3735V45.354"
          stroke="#1E1E1E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M118.805 43.3929V52.2176"
          stroke="#1E1E1E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M116.845 52.2177H120.767"
          stroke="#1E1E1E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M125.887 52.7082H134.603"
          stroke="#1E1E1E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
